// 用户协议
import React from "react";
import "./index.scss";

const PrivacyPolicy = () => {
  return (
    <div className="rule-main">
      <div class="WordSection1">
        <h3>
          <span>Personal Information Protection Policy</span>
        </h3>

        <p class="MsoNormal">
          <span lang="EN-US">
            We wish to express our gratitude (hereinafter referred to as "user"
            or "you") for visiting NovaAir's websites (hereinafter referred to
            as "we" or "NovaAir"), understanding and purchasing our company's
            products and becoming our partners. We promise to comply with the
            relevant laws and regulations and protect any personal information
            that you provide. To this end, we hereby formally inform you of our
            policies and measures for obtaining, collecting, managing and
            protecting user personal information through this "Personal
            Information Protection Policy" (hereinafter referred to as "Privacy
            Statement"). This policy applies to all affiliated companies
            invested by NovaAir’s Group abroad.
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            The Personal Information Protection Policy is the basic legal
            document for users to use NovaAir's products, services and other
            various functions. We hope that you will read it carefully before
            using the website services and certain that you have fully
            understood and are willing to accept the content of the Personal
            Information Protection Policy. Every time we update the Personal
            Information Protection Policy, your continued use of our products
            and/or services means that you agree to the updated Personal
            Information Protection Policy content and agree that we will process
            (including collection, storage, use, processing, transmission,
            provision, disclosure, deletion, etc.) your relevant information in
            accordance with the said Personal Information Protection Policy.
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            Please note that the website and other online channels may link to
            specific external websites. We shall not be responsible for the
            privacy practices of external websites or their use of your personal
            information. In addition, a link to third-party website does not
            imply that we endorse the site or the products or services
            referenced therein. We encourage users to carefully read the privacy
            policies posted on the websites you visit.
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            If you do not agree to this privacy statement, please do not access
            or use NovaAir's related products and services.
          </span>
        </p>

        <p class="MsoNormal">
          <b>
            <span lang="EN-US">
              1. Collection and Use of Personal Information
            </span>
          </b>
        </p>

        <p class="MsoNormal">
          <b>
            <span lang="EN-US">(I) Purpose of use:</span>
          </b>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">• 1. Registering as our member;</span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">• 2. Displaying and promoting products;</span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">• 3. Delivering products to you;</span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">• 4. Perform security verification;</span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">• 5. Manage products delivery business;</span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">• 6. Other purposes;</span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            If the website operation ceases, or NovaAir products and services
            are suspended or interrupted, we will issue a notice in the form of
            an announcement to stop processing your personal information and
            delete or anonymize your personal information so that others cannot
            identify the user through this information.
          </span>
        </p>

        <p class="MsoNormal">
          <b>
            <span lang="EN-US">1) Register as a member:</span>
          </b>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            If you wish to become our member and enjoy the member services we
            provide you, you need to create your website account and password
            and register as our member. During the registration process, we will
            collect your personal information, including contact name, password,
            contact information, and email address. If you register for the
            benefit of your company, please ensure that you have been properly
            authorized by your company and have the right to act on behalf of
            the company. If you log in to the website in other ways/means, we
            will request your personal information from the associated third
            party. We will ask you to provide the personal information that we
            request that the said third party is unable to provide. If you
            refuse to provide this information, it will affect your use of the
            relevant functions of NovaAir products and services. Before you
            cancel your account, we will verify your personal identity, security
            status, account password and other information. Your cancellation of
            your account is irreversible. Once you cancel your account, we will
            no longer collect your personal information, and we will immediately
            delete all information about your account or make it anonymous.
          </span>
        </p>

        <p class="MsoNormal">
          <b>
            <span lang="EN-US">2) Delivery of Goods:</span>
          </b>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            In order to deliver the product to you, you are required to provide
            the consignee's name,{" "}
            <b>
              <u>delivery address</u>
            </b>
            , postal code, consignee's contact number, etc. You must ensure the
            accuracy of the above information provided. NovaAir shall not be
            held responsible for any failure to deliver or delay in delivery due
            to inaccurate information.
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            To complete the transaction, you may also need to provide{" "}
            <b>
              <u>payment method</u>
            </b>{" "}
            and{" "}
            <b>
              <u>payment information</u>
            </b>{" "}
            so that we can verify on your payment status.
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            On some websites or online channels, you can order products for
            other individual. In this case, you need to provide the
            aforementioned personal information of the actual person ordering.
            Before providing us with the personal information of a third party,
            please make sure that you have obtained the authorization and
            consent of the third party.
          </span>
        </p>

        <p class="MsoNormal">
          <b>
            <span lang="EN-US">3) Security assurance:</span>
          </b>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            In order to provide you with better security, you may be required to
            provide us with your company's business license, order information,
            etc. to complete company user’s authentication. If you refuse to
            provide the above information, you may not be able to use certain
            functions and services of the website, but it will not affect your
            use of browsing, searching and other services.
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            In order to improve the security of your use of the website, protect
            the personal and property safety of you or other users or the public
            from infringement, better prevent various security risks, and
            accurately identify violations of laws and regulations or relevant
            agreement rules for the use of the website, we may use or integrate
            your various information, relevant network logs, and information
            that we and our partners have obtained your authorization or share
            in accordance with the law to determine your account and transaction
            risks, conduct identity verification, detect and prevent security
            incidents, and take the necessary recording, auditing, analysis, and
            disposal measures in accordance with the applicable law.
          </span>
        </p>

        <p class="MsoNormal">
          <b>
            <span lang="EN-US">
              4) Become our supplier, customer etc and other partners
            </span>
          </b>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            When you become our supplier, customer or other partner, or engage
            in business cooperation such as negotiation, consultation, and
            contract signing with us as the person in charge of our partner, we
            may process your name, phone number, email address, and position
            information based on the needs of contract signing, business
            communication, etc.
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            When you are an employee or related person (such as a driver) of our
            supplier and provide transportation and other services to NovaAir,
            we may process your name and contact number to verify your identity.
            Furthermore, in order to fulfill legal obligations and monitor the
            safety of hazardous chemical transportation, NovaAir may process
            your{" "}
            <b>
              <u>video</u>
            </b>
            ,{" "}
            <b>
              <u>image information</u>
            </b>
            ,{" "}
            <b>
              <u>location</u>
            </b>
            and{" "}
            <b>
              <u>travel trajectory</u>
            </b>
            ; in order to handle emergencies such as traffic incidents, we
            collect the name and phone number of your emergency contact. In
            order to facilitate NovaAir's third-party personnel management, we
            may process your name, gender, date of birth, mobile phone number,
            emergency contact information (name, relationship, contact number,
            contact address), certificate information (
            <b>
              <u>ID number, driver's license number</u>
            </b>
            , validity period), blood type (optional), professional
            qualification information, and designation information.
          </span>
        </p>

        <p class="MsoNormal">
          <b>
            <span lang="EN-US">5) Other uses</span>
          </b>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            When we use information for other purposes not stated in this
            policy, or use information collected for specific purposes for other
            purposes, we will seek for your prior consent.
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            When you are an employee or related person (such as a driver) of our
            supplier and provide transportation and other services to NovaAir,
            we may process your name and contact number to verify your identity.
            Furthermore, in order to fulfill legal obligations and monitor the
            safety of hazardous chemical transportation, NovaAir may process
            your video, image information, location and travel trajectory; in
            order to handle emergency events such as traffic incidents, we may
            collect the name and phone number of your emergency contact.
          </span>
        </p>

        <p class="MsoNormal">
          <b>
            <span lang="EN-US">
              6) Exceptions to obtaining authorization and consent
            </span>
          </b>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            According to relevant laws and regulations, your authorization and
            consent are not required for collecting your personal information
            under the following circumstances:
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            • (1) Necessary for the discharge and performance of a contract to
            which an individual is a party, or for the implementation of human
            resources management in accordance with labor rules and regulations
            formulated in accordance with the applicable law and collective
            contracts signed;
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            • (2) Necessary for the performance of statutory duties or statutory
            obligations;
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            • (3) Necessary for responding to public health emergencies, or for
            protecting the life, health and property safety of natural persons
            in emergency situations;
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            • (4) Processing personal information within a reasonable scope for
            news reporting, public opinion supervision and other activities in
            the public interest;
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            • (5) Processing personal information that an individual has
            disclosed on his own or that has been legally disclosed within a
            reasonable scope in accordance with the provisions of law; or
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            • (6) Other circumstances prescribed by laws and administrative
            regulations.
          </span>
        </p>

        <p class="MsoNormal">
          <b>
            <span lang="EN-US">(II) Collection methods</span>
          </b>
        </p>

        <p class="MsoNormal">
          <b>
            <span lang="EN-US">
              1. Collection when you are using the functions of NovaAir’s
              website:
            </span>
          </b>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            In order to show you products that meet your requirements better,
            understand the product suitability, and identify abnormal account
            status, we will collect information about the functions of the
            website you use and how you use it. This information includes:
          </span>
        </p>

        <p class="MsoNormal">
          <b>
            <span lang="EN-US">(1) &nbsp; Device information:</span>
          </b>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            The website will receive and record information about the device you
            use (such as device model, operating system version, device
            settings, unique device identifier and other software and hardware
            feature information) and information about the location of the
            device (such as IP address, GPS location, and sensor information
            such as WLAN access points, Bluetooth and base stations that can
            provide relevant information) based on the specific permissions you
            grant during software installation and use.
          </span>
        </p>

        <p class="MsoNormal">
          <b>
            <span lang="EN-US">(2)&nbsp;&nbsp; Log information:</span>
          </b>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            When you use the website's functions or services, the website will
            automatically collect detailed usage information of your use of the
            website's functions and services and save them as network logs. The
            aforementioned usage information includes your search query content,
            IP address, browser type, telecom operator, language used, access
            date and time, and web page records, etc.
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            We wish to highlight here, you need to note that your
            above-mentioned search keyword information cannot identify your
            personal identity alone and it does not belong to your personal
            information. Therefore, we have the right to use it for other
            purposes. Only when your search keyword information is linked to
            your other information and can identify your personal identity, then
            during the combined use, we will treat your search keyword
            information as your personal information, and process and protect it
            together with your search history in accordance with the personal
            information protection policy.
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            In order to show you the order information of all the products you
            ordered and to facilitate your order management, we will collect all
            the order information generated during the process of ordering
            products on the website.
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            When you contact us, we will save the corresponding
            communication/call records and content or your contact information
            and other related information so that we can contact you further and
            assist you in solving the problems that you have reported to us or
            record the solutions and results of such problems.
          </span>
        </p>

        <p class="MsoNormal">
          <b>
            <span lang="EN-US">
              2. Indirect obtaining of personal information:
            </span>
          </b>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            In order to confirm the product transaction status, provide you with
            product after-sales service, and resolve disputes arising from
            product transactions, we will collect your transaction,{" "}
            <b>
              <u>payment, and logistics information</u>
            </b>{" "}
            related to the transaction progress through the{" "}
            <b>
              <u>payment method, logistics arrangements</u>
            </b>
            and other information that you have chosen, or share your{" "}
            <b>
              <u>transaction information</u>
            </b>{" "}
            with the above-mentioned service providers.
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            When you use the various functions and services through the website,
            you authorize us to receive, aggregate, and analyze your personal
            information or{" "}
            <b>
              <u>transaction information</u>
            </b>{" "}
            from us and/or our affiliates based on actual business and
            cooperation needs, which we confirm is from a legitimate source or
            which you authorize to provide to us.
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            If you refuse to provide the above information or refuse to grant
            the aforementioned authorization, you may not be able to use certain
            functions and services provided by the website and our affiliated
            companies, but it will not affect the use of website browsing,
            searching and other services.
          </span>
        </p>

        <p class="MsoNormal">
          <b>
            <span lang="EN-US">2. Use of Cookies and Similar Technologies</span>
          </b>
        </p>

        <p class="MsoNormal">
          <b>
            <span lang="EN-US">(I) Cookies</span>
          </b>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            In order for the website to function properly, we will store small
            data files called Cookie on your computer or mobile device.
            Generally, the contents of Cookie files include identifiers, site
            names, and some numbers and characters. With Cookie, the website can
            store data such as your preferences or items in the shopping cart.
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            You can manage or delete Cookie by yourself, or you can clear all
            Cookie saved on your computer or mobile device by yourself. However,
            in the above case, you may need to change the relevant settings
            every time you visit our website.
          </span>
        </p>

        <p class="MsoNormal">
          <b>
            <span lang="EN-US">(II) Web beacons and pixel tags</span>
          </b>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            In addition to the aforementioned Cookie program, we will also use
            other similar technologies on the website. For example, the email we
            send to you may be attached with an address link to the website
            content. When you use the link, the website will record the usage to
            understand your preferences. For another example, the email may
            contain a pixel tag to know whether the email has been opened. If
            you do not want to use the aforementioned similar technologies, you
            can withdraw from the website's mailing list.
          </span>
        </p>

        <p class="MsoNormal">
          <b>
            <span lang="EN-US">
              3. Security protection of personal information
            </span>
          </b>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            We have developed and adopted a reasonable and feasible security
            measures system that complies with laws and regulations, industry
            standards, and is to protect your personal information from
            unauthorized access, public disclosure, use, modification, damage,
            or loss. We use encryption technology to improve the security of
            your personal information; we use certain protection mechanisms to
            protect personal information from malicious attacks; we will set up
            access control mechanisms to try to ensure that only authorized
            personnel can access personal information; we will hold internal
            training courses related to privacy and security protection.
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            We will only retain personal information for the purposes stated in
            this Personal Information Protection Policy and for the period
            prescribed by laws and regulations, unless required by relevant laws
            and regulations or with your consent.
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            You can connect and share with other users or third parties through
            the website. When you create a communication, transaction or sharing
            with the aforementioned entities, you can choose the information to
            communicate, trade or share.
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            Please use a more complex password when you become a member to help
            us protect the security of your account. We will do our best to
            protect the security of all information you send. We may update and
            disclose security risks, personal information security impact
            assessment reports and other related content from time to time, and
            you can obtain them through website announcements.
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            When a personal information security incident occurs, in accordance
            with the provisions of relevant laws and regulations, we will inform
            you by email, letter, telephone, announcement, etc. of: the overview
            and impact of the incident, corresponding disposal measures,
            suggestions for self-prevention and risk reduction, etc.
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            At the same time, we will also report the handling of personal
            information security incidents in accordance with the requirements
            of the regulatory authorities.
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            Although we have taken the above reasonable and effective measures
            and have complied with the standards required by relevant laws and
            regulations, we are still unable to guarantee the security of your
            personal information when it is communicated through unsafe
            channels. Therefore, individual users should take active measures to
            ensure the security of their personal information, such as regularly
            changing their account passwords and not disclosing their account
            passwords and other personal information to others.
          </span>
        </p>

        <p class="MsoNormal">
          <b>
            <span lang="EN-US">
              IV. Provision, entrusted processing and public disclosure of
              personal information
            </span>
          </b>
        </p>

        <p class="MsoNormal">
          <b>
            <span lang="EN-US">(I) Provide</span>
          </b>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            We will not provide your personal information to companies,
            organizations or individuals other than our affiliates and partners
            unless:
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            • (1) Explicit consent provided: We may provide your personal
            information to third parties after obtaining your separate consent
            and fulfilling other legal obligations.
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            • (2) Sharing with affiliates: Your personal information may be
            shared with our affiliates to facilitate our affiliates to provide
            you with some services, or to protect the personal and property
            safety of our affiliates or other users or the public from
            infringement. We will only share necessary personal information. If
            the scope, purpose or processing method of sharing your personal
            information changes, we will obtain your authorization and consent
            again; or
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            • (3) Provide under statutory circumstances: We may provide your
            personal information in accordance with laws and regulations,
            litigation dispute resolution needs, or administrative and judicial
            authorities’ legal requirements.
          </span>
        </p>

        <p class="MsoNormal">
          <b>
            <span lang="EN-US">(II) Entrusted processing</span>
          </b>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            • (1) When you trade products on the website, we may entrust
            third-party service providers to process your personal information
            because third-party services, such as logistics and installation,
            are required to fulfill the agreement and deliver the products.
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            • (2) For the purposes stated in this Privacy Policy only, some of
            our services will be provided by our authorized partners. We will
            only disclose your personal information for legitimate, lawful,
            necessary, specific and clear purposes, and will only disclose
            personal information necessary for the service. Our partners have no
            right to use the obtained personal information for other purposes
            unrelated to products or services.
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            For companies, organizations and individuals that obtain the shared
            personal information provided by us, they will sign a strict data
            protection agreement requiring them to process and use personal
            information in accordance with relevant laws and regulations, our
            instructions, this Privacy Policy and any other relevant protection
            measures.
          </span>
        </p>

        <p class="MsoNormal">
          <b>
            <span lang="EN-US">(III) Transfer</span>
          </b>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            Generally, we will not transfer personal information to any company,
            organization or individual, except under the following
            circumstances:
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            • (1) Transfer with your consent: We may transfer your personal
            information to a third party with your explicit consent; or
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            • (2) If your personal information needs to be transferred due to
            merger, division, dissolution, bankruptcy, etc. of the website
            service provider, we will inform you of the name and contact
            information of the recipient and require the new company or
            organization holding your personal information to continue to be
            bound by this policy. Otherwise, we will require the company,
            organization or individual to re-ask your authorization and consent.
          </span>
        </p>

        <p class="MsoNormal">
          <b>
            <span lang="EN-US">(IV) Public Disclosure</span>
          </b>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            We will only disclose your personal information under the following
            circumstances:
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            • (1) We may disclose your personal information publicly with your
            separate consent;
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            • (2) If we determine that you have violated laws and regulations or
            seriously violated the relevant agreement rules of the website, or
            in order to protect the personal and property safety of us, our
            affiliates, users or the public from infringement, we may disclose
            your personal information in accordance with laws and regulations or
            the relevant agreement rules of the website with your separate
            consent.
          </span>
        </p>

        <p class="MsoNormal">
          <b>
            <span lang="EN-US">
              (V) Exceptions to prior authorization for sharing, transferring,
              and publicly disclosing personal information
            </span>
          </b>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            Sharing, transferring, and publicly disclosing your personal
            information requires your prior authorization and consent, unless:
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            • (1) Necessary for the discharge and performance of a contract to
            which an individual is a party, or for the implementation of human
            resources management in accordance with labor rules and regulations
            formulated in accordance with the applicable law and collective
            contracts signed;
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            • (2) Necessary for the performance of statutory duties or statutory
            obligations;
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            • (3) Necessary for responding to public health emergencies, or for
            protecting the life, health and property safety of natural persons
            in emergency situations;
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            • (4) Processing personal information within a reasonable scope for
            news reporting, public opinion supervision and other activities in
            the public interest;
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            • (5) Processing personal information that an individual has
            disclosed on his own or that has been legally disclosed within a
            reasonable scope in accordance with the provisions of law; or
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            • (6) Other circumstances prescribed by laws and administrative
            regulations.
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            According to the law, processing anonymized personal information and
            ensuring that the data recipient cannot restore and re-identify the
            subject of the personal information does not constitute processing
            of personal information (including entrusted processing, provision,
            joint processing, transfer and public disclosure), and the
            processing of such data will not require additional notification to
            you and your consent.
          </span>
        </p>

        <p class="MsoNormal">
          <b>
            <span lang="EN-US">5. Self-management of personal information</span>
          </b>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            You can independently access and manage the personal information
            that you have provided in the following ways:
          </span>
        </p>

        <p class="MsoNormal">
          <b>
            <span lang="EN-US">(I) Access to Personal Information</span>
          </b>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            You have the right to access the personal information that you have
            provided, except where otherwise required by laws and regulations.
            You can independently access the personal information that you have
            provided through the account management and personal information
            management interfaces in the relevant websites and applications.
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            If you are unable to access, modify or delete your personal
            information through the above methods, you can contact us at any
            time through the contact information under this Privacy Policy, and
            we will respond to your request within 15 days.
          </span>
        </p>

        <p class="MsoNormal">
          <b>
            <span lang="EN-US">
              (II) Correction and modification of personal information
            </span>
          </b>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            If you find that there is an error in your personal information, you
            can request for correction or modification.
          </span>
        </p>

        <p class="MsoNormal">
          <b>
            <span lang="EN-US">(III) Deletion of Personal Information</span>
          </b>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            You may request us to delete your personal information under the
            following circumstances:
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            • (1) If our handling of personal information violates laws and
            regulations;
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            • (2) If we collect and use your personal information without
            obtaining your prior consent;
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            • (3) If our handling of personal information seriously violates
            other agreements between you and us;
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">• (4) If you actively cancel your account;</span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            • (5) If we no longer provide services to you;
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">• (6) Other reasons.</span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            Unless otherwise required by laws and regulations, or with your
            independent authorization, if we decide to delete your personal
            information, we will simultaneously notify the entity that obtained
            your personal information from us as much as possible and request it
            to delete it in a timely manner.
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            When you delete information from our services, we will delete it
            when we update our backup system.
          </span>
        </p>

        <p class="MsoNormal">
          <b>
            <span lang="EN-US">(IV) Changes in the scope of authorization</span>
          </b>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            Certain business functions on the website require some basic
            personal information to be completed. In addition, for the
            collection and use of additional personal information, you can set
            it on the website operation interface or contact us to give, modify
            or withdraw your authorization consent. However, your decision to
            withdraw or modify the authorization will not affect the personal
            information processing previously carried out based on your
            authorization.
          </span>
        </p>

        <p class="MsoNormal">
          <b>
            <span lang="EN-US">(V) Account cancellation</span>
          </b>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            You can submit an account cancellation application on the relevant
            operation page by yourself.
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            After you cancel your account on your own initiative, we will stop
            providing you with the corresponding services and delete your
            personal information or make it anonymous in accordance with
            applicable laws.
          </span>
        </p>

        <p class="MsoNormal">
          <b>
            <span lang="EN-US">(VI) Request processing</span>
          </b>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            To protect the security of your personal information, we may ask you
            to verify your identity before processing your request. We will
            respond within 15 days.
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            Under the following circumstances, we will not be able to process
            your request in accordance with laws and regulations:
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            • &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; (1) related to national security
            and national defense security;
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            • &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; (2) related to public security,
            public health, and major public interests;
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            • &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; (3) related to criminal
            investigation, prosecution, trial, and execution of judgments;
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            • &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; (4) there is sufficient evidence to
            show that the subject of personal information has subjective malice
            or abuses his rights;
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            •<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>
          </span>
          <span lang="EN-US">
            &nbsp;(5) responding to your request will cause serious damage to
            the legitimate rights and interests of you or other individuals or
            organizations;
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">&nbsp;</span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            • &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; (6) involving commercial secrets
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            • &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; (7) other reasons stipulated by
            laws and regulations.
          </span>
        </p>

        <p class="MsoNormal">
          <b>
            <span lang="EN-US">
              VI. Global Transfer of Personal Information
            </span>
          </b>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            The personal information we collect and generate during our
            operations within the territory of Malaysia, except in the following
            circumstances:
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            • &nbsp;&nbsp;&nbsp; (1) Clearly stipulated by laws and regulations;
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            •<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>
          </span>
          <span lang="EN-US">
            &nbsp;(2) Obtain your separate consent and fulfill other relevant
            compliance obligations;
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            •&nbsp;&nbsp;&nbsp;&nbsp; (3) Your personal initiative such as
            conducting cross-border transactions through the Internet.
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            In the above circumstances, we will do our best to protect your
            personal information in accordance with specific applicable laws and
            regulations and our other policies.
          </span>
        </p>

        <p class="MsoNormal">
          <b>
            <span lang="EN-US">
              VII. Updates to the Personal Information Protection Policy
            </span>
          </b>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">Our privacy policy may subject to changes.</span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            Without your explicit consent, we will not restrict your rights
            under the Personal Information Protection Policy. We will publish
            any changes to the Personal Information Protection Policy on a
            dedicated page.
          </span>
        </p>

        <p class="MsoNormal">
          <b>
            <span lang="EN-US">8. Dispute Resolution</span>
          </b>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            If you have any dispute with us due to the implementation of this
            personal information protection policy, both parties shall first
            negotiate to resolve it in an amicable manner; if the dispute cannot
            be resolved through negotiation, both parties shall have the right
            to resort to arbitration in Malaysia.
          </span>
        </p>

        <p class="MsoNormal">
          <b>
            <span lang="EN-US">IX. Contact Us</span>
          </b>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            You can contact us in the following ways and we will respond to your
            request within 15 days:
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">&nbsp;</span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            • &nbsp;&nbsp;&nbsp; (1) If you have any questions, comments or
            suggestions about the content of this policy, you can contact
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; us through the
            online customer service;
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            • &nbsp;&nbsp;&nbsp; (2) We have also set up a special mailbox for
            personal information protection, and you can contact it
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            through (inquiry@novaair.co).
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            • &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; (3) If you are not satisfied with
            our response, especially if you believe that our personal
            information processing behavior has damaged your legal rights and
            interests, you can also seek a solution by filing a lawsuit in the
            court with jurisdiction over the defendant's place of residence.
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">&nbsp;</span>
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
